<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut')
                }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('photo.title') }}</div>
                <div class="mainBody mainContent">
                    <p @click="path('photo', '大会照片')">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/17.png" alt="">
                        {{ $t('photo.menu1') }}
                    </p>
                    <p @click="path('videos', '视频集锦')">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/18.png" alt="">
                        {{ $t('photo.menu2') }}
                    </p>
                    <!-- <p @click="path('say')">
                        <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2022/zy.png?v=0223" alt="">
                        <span>
                            {{ $t('photo.menu3') }}
                        </span>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            toastShow: false,
            toastText: "",
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/photo']);

    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        }, toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path, name) {
            let that = this, data = new FormData();
            data.append('title', name)
            if (path == 'photo') {
                that.axios.post('menu', data).then((res) => {
                    if (res.data.code == 200) {
                        if (res.data.type == 1) {
                            window.location.href = res.data.address;
                        } else {
                            that.toast(that.$t('back.waiting'));
                        }
                    } else {
                        that.toast(res.data.msg);
                    }
                }).catch(err => err);
            } else if (path == 'videos') {
                that.axios.post('menu', data).then((res) => {
                    if (res.data.code == 200) {
                        if (res.data.type == 1) {
                            that.$router.replace('/' + path).catch((err) => err);
                        } else {
                            that.toast(that.$t('back.waiting'));
                        }
                    } else {
                        that.toast(res.data.msg);
                    }
                }).catch(err => err);
            } else if (path == 'menu') {
                that.$router.replace('/menu').catch((err) => err);
            } else if (path == 'say') {
                that.$router.replace('/say').catch((err) => err);
            }
        }
    }
}
</script>
<style scoped>
.mainContent {
    width: 6rem;
    min-height: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.mainContent>p {
    width: 5.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    font-size: .3rem;
    align-items: center;
    background-size: 100%;
    text-shadow: 0px .04rem .04rem rgba(17, 107, 103, 0.51);
    border-bottom: 1px solid #fff;
    margin-bottom: 0;
}

.mainContent>p:last-child {
    border-bottom: none;
}

.mainContent>p>img {
    width: 0.75rem;
    margin-right: .35rem;
}
</style>


// WEBPACK FOOTER //
// src/views/photo.vue